import React from "react";
import MarkdownPage from "../components/MarkdownPage";

function Works() {
  return <MarkdownPage markdownPath="/markdown/works.md" />;
}

export default Works;
